import { Component, OnInit } from '@angular/core';
import { CommandsService } from '../services/commands.service';
import { LanguageService } from '../services/language.service';
import { CanvasService } from '../services/canvas.service';
import { EditorContentService } from '../services/editorcontent.service';
import { TurtleService } from '../services/turtle.service';

import { CanvasComponent } from './canvas.component';
import { InputComponent } from './input.component';
import { SessionStorageService } from '../services/sessionstorage.service';
import { BlocksService } from '../services/blocks.service';
import { BluetoothService } from '../services/bluetooth.service';

declare var require: (...any) => any;
declare var ace: any;

@Component({
  selector: 'app-root',
  host: {
    '(document:keyup)': 'keyup($event)'
  },
  templateUrl: './app.component.html',
  providers: [LanguageService, EditorContentService, CommandsService, TurtleService, CanvasService, SessionStorageService, BlocksService, BluetoothService]
})

export class AppComponent implements OnInit {

  //IMPORTANT: This declaration is expected to be on line 29 at all times
	private MODE = 1;
	//private MODE = 1; private MODE = 2;

  // Data sharing with other components
  private et: EditorContentService;
  private la: LanguageService;
  private cs: CommandsService;
  private ts: TurtleService;
  private canS: CanvasService;
  private sessionstorage: SessionStorageService;
  private blocks: BlocksService;

  // Variables related to
  static editor: any;

  // proportion of the left side (editor)
  private WIDTH = '40%';

  // variables used to check whether thing are used, which styleSheet we use and the current padding
  private resizeOn = false;
  private padding: number;
  private inputused = true;

  //Logging
  static LOGGING = false;
  static STORAGELOCATION = "digitaltag";

  // variables used to check whether thing are used, which styleSheet we use and the current padding
  private showLeftSideContent = true;

  constructor(private bs: BluetoothService, private sessionstorageService: SessionStorageService, private languageService: LanguageService, private editorContentService: EditorContentService, private commandsService: CommandsService, private turtleService: TurtleService, private canvasService: CanvasService, private blocksService: BlocksService) {

    // initiate data sharing variables for child components
    this.la = languageService;
    this.et = editorContentService;
    this.cs = commandsService;
    this.ts = turtleService;
    this.canS = canvasService;
    this.sessionstorage = sessionstorageService;
    this.blocks = blocksService;

    // set mode to given parameter from input script
    this.blocks.setMode(this.MODE);
    // always clear screen before execution?
    this.blocks.disableClearScreenBeforeExec();


    // set padding for all visible elements to 2% initially
    this.padding = 2 * window.innerWidth / 100;

    // Close the dropdown if the user clicks outside of it
    window.onclick = function (event: MouseEvent) {
      // check whether dropdown menu was clicked or something else
      let el = <Element>event.target;
      let selector = '.headerbtn';
      let p = Element.prototype;
      let f = p.matches || p.webkitMatchesSelector || p.msMatchesSelector || function (s) {
        return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
      };

      // check whether dropdown menu was clicked or not
      let a = f.call(el, selector);

      // if it was not clicked, then close the dropdown menu
      if (!a) {
        let dropdowns = document.getElementsByClassName('dropdown-content');
        let i;
        for (i = 0; i < dropdowns.length; i++) {
          let openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    };

  }

  // stop working, called when user interrupts computation, in case it takes too long
  stop() {
    CanvasComponent.stop = true;
  }

  // hide the main dropdown menu
  untoggle() {
    let dropdowns = document.getElementsByClassName('dropdown-content');
    let i;
    for (i = 0; i < dropdowns.length; i++) {
      let openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show');
      }
    }
  }

  // check if arrow up or arrowdown are pressed
  keyup(event: KeyboardEvent) {
    // arrow up/down is only enabled if no focus on editor
    if (!this.editorContentService.onEditorFocus) {
      if (event.keyCode === 38) {
        this.commandsService.getCommand(38);
      } else if (event.keyCode === 40) {
        this.commandsService.getCommand(40);
      }
    }
  }


  ngOnInit() {

    // load editor
    AppComponent.editor = ace.edit('editor');
    AppComponent.editor.setTheme('ace/theme/kr_theme');
    AppComponent.editor.getSession().setMode('ace/mode/python');
    AppComponent.editor.setOption('tabSize', 2);
    AppComponent.editor.session.setUseWrapMode(true);
    AppComponent.editor.session.setOption("indentedSoftWrap", false);
    AppComponent.editor.commands.bindKeys({"Ctrl-L": null, "Ctrl-F": null});

    // register on focus for editor
    AppComponent.editor.on('focus', function () {
      this.editorContentService.onEditorFocus = true;
    }.bind(this), false);

    // register on blur for editor
    AppComponent.editor.on('blur', function () {
      this.editorContentService.onEditorFocus = false;
    }.bind(this), false);

    //prepare Tabs
    this.editorContentService.prepareTabs();

  }

  // check whether user grasped bar in middle of screen to initiate resizing
  resizeStart() {
    this.resizeOn = true;
  }

  // if resizing: check if mouse was released, then stop resizing
  resizeStop(e: MouseEvent) {
    if (this.resizeOn) {
      this.resizeOn = false;
      this.WIDTH = e.clientX - this.padding + 'px';

    }
  }

  // perform window resizing
  resize(e: MouseEvent) {
    if (this.resizeOn) {
      let value: number = e.clientX - this.padding;
      this.WIDTH = value + 'px';
      if (value < this.padding * 5) {
        this.showLeftSideContent = false;
      } else {
        this.showLeftSideContent = true;
      }

      if (value > window.innerWidth - window.innerWidth / 5) {
        this.inputused = false;
      } else {
        this.inputused = true;
      }

      // Resize Canvas
      CanvasComponent.updateDimension();

      // resize the editor
      AppComponent.editor.resize();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app.component.ts